import React, { PropTypes } from 'react';
import { LinearProgress, CircularProgress, RaisedButton } from 'material-ui';
import R from 'ramda';
import pluralize from 'pluralize';

const propTypes = {
  hashToken: PropTypes.string,
  rates: PropTypes.array,
  requests: PropTypes.array,
  processingToken: PropTypes.bool,
  gettingAssets: PropTypes.bool,
  errorText: PropTypes.string,
};

class AssetsConsolidationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      completed: Math.random() * 80,
      seconds: 0,
    };
  }
  componentDidMount() {
    if (!this.timer) this.timer = setInterval(() => this.progress(), 1000);
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.completed < 100 && this.state.seconds >= 8 && nextProps.consolidationSuccess) {
      this.setState({ completed: 100 });
    }
  }

  progress = () => {
    const diff = Math.random() * (90 - (this.state || {}).completed);
    const newVal = (this.state || {}).completed + diff;
    const seconds = (this.state || {}).seconds;
    if (this.props.errorText) {
      clearInterval(this.timer);
    } else if (this.props.consolidationSuccess && seconds >= 5) {
      this.setState({ completed: 100, seconds: seconds + 1 });
      clearInterval(this.timer);
    } else {
      this.setState({ completed: newVal, seconds: seconds + 1 });
    }
  }
  render() {
    const {
      gettingAssets,
      rates,
      requests,
      companyType,
      associateEmail,
      consolidationSuccess,
      errorText,
    } = this.props;
    const assetLabel = companyType === 'Supplier' ? 'Requests' : 'Contracts';
    const docs = (companyType === 'Supplier' ? requests : rates) || [];
    return (
      <div className="full-screen-page" style={{ padding: '150px 20%', textAlign: 'center' }} >
        {
          Boolean(gettingAssets) && (
            <div style={{ fontSize: '16px' }}>
              Processing...
            </div>
          )
        }
        {
          Boolean(errorText) && (
            <div style={{ fontSize: '16px' }}>
              {errorText}
            </div>
          )
        }
        {
          !gettingAssets && this.state.completed < 100 && !errorText && (
            <div style={{ fontSize: '16px', width: '70%', margin: 'auto' }}>
              We are adding {associateEmail ? `${associateEmail} as an associated email, and ` : ''}{docs.length} {pluralize(assetLabel, docs.length)} to your account. Thank you for your patience.
            </div>
          )
        }
        {
          this.state.completed >= 100 && (
            <div style={{ fontSize: '16px', width: '70%', margin: 'auto'  }}>
              {
                associateEmail
                  ? `Congratulations! We've added ${associateEmail}, and the ${pluralize(assetLabel, docs.length)} sent to that email address to your account.`
                  : `Congratulations! We've added ${(docs || []).length} ${pluralize(assetLabel, docs.length)} to your account.`
              }

            </div>
          )
        }
        <LinearProgress style={{ flexGrow: 1, height: '12px', borderRadius: '5px', width: '50%', margin: '32px auto' }} color="#0097a7" mode="determinate" max={100} min={0} value={this.state.completed} />
        {
          Boolean(this.state.completed >= 100) && (
            <RaisedButton
              data-cy="goto-contract-list"
              label="View Contract List"
              labelStyle={{ textTransform: 'none' }}
              secondary
              onTouchTap={() => this.context.router.push(`/contracting/contract-list/recent`)}
            />
          )
        }
      </div>
    );
  }
}

AssetsConsolidationComponent.propTypes = propTypes;
AssetsConsolidationComponent.contextTypes = {
  router: PropTypes.object.isRequired,
}
export default AssetsConsolidationComponent;




// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/dumb-component.jsx